import authRequest from '@/modules/auth-request';
import http from '@/modules/http';
import User from '@/store/models/user';

function getUser() {
	return authRequest.get('AUTH_API://me');
}

export default {

	getUser(){
		return getUser()
			.then(http.resolveData, http.rejectData)
			.then(user => {
				return Promise.all([this.getAddresses(), this.getCountryByIp()])
					.then(resp => {
						user.addresses = resp[0];
						user.ipInfo = resp[1];
						return user;
					});
			})
			.then(user => {
				return User.fromDTO(user);
			});
	},

	getAddresses() {
		return authRequest.get('AUTH_API://me/addresses')
			.then(http.resolveData, http.rejectData);
	},

	getExportStatus() {
		return authRequest.get('AUTH_API://me/ecac-status')
			.then(http.resolveData, http.rejectData);
	},

	getCountryByIp() {
		return authRequest.get('AUTH_API://ip')
			.then(http.resolveData, http.rejectData);
	},

	createAddress(payload) {
		return authRequest.post('AUTH_API://me/addresses', payload)
			.then(http.resolveData)
			.catch(reason => {
				let response = reason.response;
				const suggestions = response.data && response.data.suggestions;
				const original = response.data && response.data.original;


				if (suggestions && suggestions.length > 0) {
					response.data.suggestions = suggestions;
					return Promise.reject(response.data);
				}

				if (original) {
					response.data.original = original;
					response.data.suggestions = null;
					return Promise.reject(response.data);
				}

				return http.rejectData(reason);
			});
	},

	updateUser(payload) {
		return authRequest.patch('AUTH_API://me', payload)
			.then(http.resolveData, http.rejectData);
	},

	changePassword(payload) {
		return authRequest.post('AUTH_API://me/change-password', payload)
			.then(http.resolveData, http.rejectData);
	},

	changeEmail(payload) {
		return authRequest.patch('AUTH_API://me/email', payload)
			.then(http.resolveData, http.rejectData);
	},

	confirmEmail(payload) {
		return authRequest.get('AUTH_API://me/email/confirm/' + payload)
			.then(http.resolveData, http.rejectData);
	},

	verifyEmail(payload) {
		return authRequest.post('AUTH_API://verify-email')
			.then(http.resolveData, http.rejectData);
	},

	getEmailVerified(){
		return getUser()
			.then(http.resolveData, http.rejectData)
			.then(userInfo => {
				return userInfo.user.emailVerified;
			});
	},

	createTfa() {
		return authRequest.post('AUTH_API://me/security/mfa')
			.then(http.resolveData, http.rejectData);
	},

	enableTfa(payload) {
		return authRequest.put('AUTH_API://me/security/mfa', payload)
			.then(http.resolveData, http.rejectData);
	},

	disableTfa(payload) {
		return authRequest.delete('AUTH_API://me/security/mfa', {
			data: payload
		})
			.then(http.resolveData, http.rejectData);
	},

	deleteAccount(payload) {
		return authRequest.delete('AUTH_API://users', {
			data: payload
		})
			.then(http.resolveData, http.rejectData);
	}

};



// WEBPACK FOOTER //
// ./src/modules/user-api.js